import React, { useState, useRef, useContext, useEffect } from "react";
import { useForm } from "react-hook-form";

// contexts
import AuthContext from "../../contexts/authContext";

// API
import { postData, apiURL, getData } from "../../services/API";

// components
import Verification from "./Verification";
import Stepper from "../../components/shared/Stepper";
import Loading from "../../components/shared/Loading";
import NoticeMsg from "../../components/shared/NoticeMsg";
import ProfileInfo from "./CompleteRegister";
import Password from "./Password";

// forms & api
import Input from "../../components/shared/Form/Input";
import config from "./config.json";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { setItemStorage } from "../../Localstorage/useLocalStorage";

const Auth = () => {
  const {
    api_url: { p_get_login_sms_code, p_change_pass_code },
  } = config;

  const { register, getValues } = useForm();

  // context
  const authContext = useContext(AuthContext);

  const [phoneNumber, setPhoneNumber] = useState("");
  const [isRegistered, setIsRegistered] = useState(null);
  const [serverRes, setServerRes] = useState({});
  const [loading, setLoading] = useState(false);
  const [validate, setValidate] = useState(false);
  const [err, setErr] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [stepper, setStepper] = useState(1);
  const [resetPassword, setResetPassword] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [isComplite, setIsComplite] = useState(false);

  const loc = useLocation();

  const params = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    if (params.ref) {
      setItemStorage("ref", params.ref);
      navigate({
        pathname: "/shop",
      });
    }

    setIsRegistered(null);
    setResetPassword(false);
    setChangePassword(false);
    setValidate(false);
    setLoading(false);
    setStepper(1);
    setIsComplite(false);
  }, [loc]);

  // prevent to type letters
  const onChangeHandler = (e) => {
    const onlyNum = /^[0-9\b]+$/;

    if (e.target.value === "" || onlyNum.test(e.target.value)) {
      setPhoneNumber(getValues("phone_number"));
    }
  };

  const submitHandler = (e, url, resetPass) => {
    e.preventDefault();
    // phone number lentgh limit
    const limitNum = /^0.{10,10}$/;

    // post data to api
    if (limitNum.test(phoneNumber)) {
      setErr(false);
      setLoading(true);

      postData(url, getValues(), false)
        .then((res) => {
          if (res.data.status === "success") {
            setServerRes(res);
            authContext.userPhoneNumber(res.data, phoneNumber);
            // !resetPass &&
            //   (res.data.description === "code"
            //     ? setIsRegistered(false)
            //     : setIsRegistered(true));
            //     if (resetPass) {
            //     setChangePassword(true);
            //     setIsRegistered(false);
            //       setResetPassword(false);
            //     }

            if (res.data.description !== "code") {
              setIsRegistered(true);
              setStepper(2);
            }

          }

          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          setErr(true);
          setErrMsg(err.response?.data.phone_number);
        });
    } else {
      setErr(true);
      setValidate(true);
    }
  };

  const backBtnHandler = () => {
    setIsRegistered(null);
    setChangePassword(false);
    setResetPassword(false);
    setStepper(1);
    setErr(false);
  };

  const passwordRecoveryHandler = () => {
    setResetPassword(true);
    setErr(false);
    setErrMsg("");
    // setPhoneNumber("");
  };

  return (
    <div className="min-h-screen h-fit overflow-y-auto py-6 w-full flex flex-col gap-5 justify-center items-center pb-28 lg:pb-6 px-4">
      <Link
        to={"https://hotelaroos.ir"}
        className="text-[#2f52ef] text-sm absolute top-5 left-5"
      >
        بازگشت به سایت
      </Link>

      {/* <Stepper stepNum={stepper} registered={isRegistered} /> */}
      <div className="lg:w-[400px] overflow-hidden w-full h-auto rounded-xl p-4 bg-white shadow-lg ">
        <div className="relative py-2 mb-3">
          <h1 className="text-center text-2xl font-extrabold text-gray-800">
            {resetPassword || changePassword ? (
              <span>بازیابی رمز عبور</span>
            ) : authContext.userInfo.completeProfile && isComplite ? (
              <span>تکمیل اطلاعات کاربری</span>
            ) : (
              <span>ورود یا ثبت نام</span>
            )}
          </h1>
          <button
            onClick={backBtnHandler}
            className={`absolute ${
              (isRegistered !== null && !isComplite) || resetPassword
                ? "block"
                : "hidden"
            } border rounded-lg right-0 top-2/4 -translate-y-2/4 p-1 hover:bg-slate-100 transition-all duration-300`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-[18px] h-[18px] stroke-slate-500"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
              />
            </svg>
          </button>
        </div>

        {err && (
          <NoticeMsg
            msg={
              errMsg
                ? errMsg
                : validate
                ? "فیلد شماره موبایل الزامی میباشد."
                : "لطفا دوباره تلاش کنید."
            }
            notice={"error"}
          />
        )}

        {/* auth enter phone number */}
        {isRegistered === null && !isComplite && !resetPassword && (
          <form
            onSubmit={(e) => submitHandler(e, p_get_login_sms_code.url, false)}
            onChange={onChangeHandler}
            className={`login-form flex flex-col gap-4 mt-6 transition-all duration-300`}
          >
            <Input
              element={"input"}
              type={p_get_login_sms_code.input.phone_number.type}
              label={p_get_login_sms_code.input.phone_number.label}
              placeHolder={`${p_get_login_sms_code.input.phone_number.label} خود را وارد کنید`}
              register={{ ...register("phone_number") }}
              value={phoneNumber}
              className={"text-lg placeholder:text-sm scaleAnimation"}
              aos={"slide-up"}
            />
            {/* submit button */}
            <button
              className="bg-blue scaleAnimation animate-delay-2 opacity-0 text-white w-full h-11 rounded-xl   transition-all duration-300"
              type="submit"
            >
              {loading ? (
                <Loading color={"before:!bg-white"} />
              ) : (
                "ورود به پنل مدیریت"
              )}
            </button>
          </form>
        )}

        {/* reset password enter phone number */}
        {resetPassword && (
          <form
            onSubmit={(e) => submitHandler(e, p_change_pass_code.url, true)}
            onChange={onChangeHandler}
            className={`reset-pass flex flex-col gap-4 mt-6 transition-all duration-300`}
          >
            <Input
              element={"input"}
              className="text-lg placeholder:text-sm scaleAnimation"
              type={p_get_login_sms_code.input.phone_number.type}
              label={p_get_login_sms_code.input.phone_number.label}
              placeHolder={`${p_get_login_sms_code.input.phone_number.label} خود را وارد کنید`}
              register={{ ...register("phone_number") }}
              value={phoneNumber}
            />

            {!loading ? (
              // submit button
              <button
                className="bg-blue scaleAnimation animate-delay-2 opacity-0 text-white w-full h-11 rounded-xl   transition-all duration-300"
                type="submit"
              >
                <span> بازیابی رمز عبور </span>
              </button>
            ) : (
              <Loading />
            )}
          </form>
        )}

        {/* forget password */}
        {isRegistered === null && !resetPassword && (
          <button
            onClick={passwordRecoveryHandler}
            className="text-[#4567ff] mt-4 animate-delay-4 scaleAnimation opacity-0"
          >
            رمز عبور خود را فراموش کرده اید؟
          </button>
        )}

        {/* verification */}
        {isRegistered === false && !isComplite && (
          <Verification
            data={serverRes}
            registered={isRegistered}
            resetPassword={changePassword}
            setStepNum={setStepper}
            phoneNumber={getValues("phone_number")}
            setIsComplite={setIsComplite}
          />
        )}

        {/* login enter password */}
        {isRegistered && <Password setStepNum={setStepper} />}

        {/* complete register */}
        {authContext.userInfo.completeProfile && isComplite && (
          <ProfileInfo setStepNum={setStepper} />
        )}
      </div>
    </div>
  );
};

export default Auth;
